import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import useApiService from "../../../hooks/useApiService";
import { verifyEmail } from "../../../services/auth-service/authService";
import Spinner from "../../../components/common/spinner/Spinner";

const centeredPage: React.CSSProperties = {
  minHeight:      "calc(100vh - 68px)",
  display:        "flex",
  alignItems:     "center",
  justifyContent: "center",
  background:     "linear-gradient(135deg, #f8fafc 0%, #fef2f2 100%)",
  padding:        "2rem 1rem",
};

const card: React.CSSProperties = {
  width:        "100%",
  maxWidth:     420,
  background:   "#ffffff",
  borderRadius: 20,
  boxShadow:    "0 8px 40px rgba(0,0,0,0.09)",
  border:       "1.5px solid #f0f4f8",
  padding:      "3rem 2.5rem",
  textAlign:    "center",
};

function EmailVerificationPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const data = searchParams.get("data") || "";

  const { loading, error } = useApiService({
    serviceCall: () => verifyEmail({ data }),
    dependencies: [],
  });

  if (loading) return <Spinner />;

  if (error) {
    return (
      <div style={centeredPage}>
        <div style={card}>
          <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 72, height: 72, borderRadius: "50%", background: "rgba(237,27,36,0.08)", marginBottom: "1.5rem" }}>
            <FaTimesCircle size={30} color="#ed1b24" />
          </div>
          <h2 style={{ fontWeight: 800, fontSize: "1.4rem", color: "#1e293b", letterSpacing: "-0.03em", marginBottom: "0.5rem" }}>
            Verification Failed
          </h2>
          <p style={{ color: "#64748b", fontSize: "0.9375rem", marginBottom: "2rem" }}>{error}</p>
          <button onClick={() => navigate("/")} className="btn btn-danger px-4" style={{ borderRadius: "50rem", fontWeight: 600 }}>
            Back to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={centeredPage}>
      <div style={card}>
        <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 72, height: 72, borderRadius: "50%", background: "rgba(5,150,105,0.09)", marginBottom: "1.5rem" }}>
          <FaCheckCircle size={30} color="#059669" />
        </div>
        <h2 style={{ fontWeight: 800, fontSize: "1.4rem", color: "#1e293b", letterSpacing: "-0.03em", marginBottom: "0.5rem" }}>
          Email Verified!
        </h2>
        <p style={{ color: "#64748b", fontSize: "0.9375rem", marginBottom: "2rem" }}>
          Your email has been successfully verified.<br />You can now sign in to your account.
        </p>
        <button onClick={() => navigate("/login")} className="btn btn-danger px-4" style={{ borderRadius: "50rem", fontWeight: 600 }}>
          Sign In
        </button>
      </div>
    </div>
  );
}

export default EmailVerificationPage;
